import * as S from './styles'

type GuideTourStepCardFooterProps = Readonly<{
  continueLabel: string
  isFirstStep: boolean
  isSummaryOnly: boolean
  blockedTargetInteractionFeedbackKey: number | undefined
  onSkip: () => void
  onNext: () => void
  onPrev: () => void
}>

export function GuideTourStepCardFooter({
  continueLabel,
  isFirstStep,
  isSummaryOnly,
  blockedTargetInteractionFeedbackKey,
  onSkip,
  onNext,
  onPrev,
}: GuideTourStepCardFooterProps) {
  return (
    <S.Footer>
      {isSummaryOnly ? (
        <span aria-hidden />
      ) : (
        <S.GhostButton type="button" onClick={onSkip}>
          Dispensar
        </S.GhostButton>
      )}

      <S.Actions>
        {!isSummaryOnly && !isFirstStep ? (
          <S.SecondaryButton type="button" onClick={onPrev}>
            Anterior
          </S.SecondaryButton>
        ) : null}
        <S.PrimaryButton
          type="button"
          onClick={onNext}
          $pulseTrigger={blockedTargetInteractionFeedbackKey}
        >
          {continueLabel}
        </S.PrimaryButton>
      </S.Actions>
    </S.Footer>
  )
}
